<template>
    <div  v-if="refresh" data-cy="container_modal_shipping_address_form_fields">
        <InputTextBorder
            v-model:inputValue="formModel.firstname"
            :errorInfo="errorInfo[0]"
            :isShowError="true"
            :isSubmitted="isSubmitted"
            :inputLbl="lbl.shipping.firstname"
            data-cy="input_modal_shipping_address_firstname"
            @onClick="onTracking('firstname')"
            @update:inputValue="onFormUpdateValue()"
        ></InputTextBorder>
        <InputTextBorder
                v-model:inputValue="formModel.lastname"
                :errorInfo="errorInfo[1]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.shipping.lastname"
                data-cy="input_modal_shipping_address_lastname"
                @onClick="onTracking('lastname')"
                @update:inputValue="onFormUpdateValue()"
        ></InputTextBorder>
        <InputContactNumberBorder
            v-model:inputValue="formModel.contactNumber"
            :minLength="12"
            :maxLength="12"
            delimeter="-"
            :numLength="10"
            :errorInfo="errorInfo[2]"
            :isShowError="true"
            :isSubmitted="isSubmitted"
            :inputLbl="lbl.shipping.contactnumber"
            data-cy="input_modal_shipping_address_contact"
            @onClick="onTracking('mobile')"
            @update:inputValue="onFormUpdateValue()"
        ></InputContactNumberBorder>
        <InputTextBorder
                v-model:inputValue="formModel.addressName"
                :errorInfo="errorInfo[3]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.shipping.address"
                data-cy="input_modal_shipping_address_address"
                @onClick="onTracking('address')"
                @update:inputValue="onFormUpdateValue()"
        ></InputTextBorder>
        <FormAddressDropdown
                v-model:inputValue="formModel"
                :errorInfo="errorInfo[4]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.shipping"
                data-cy="container_modal_shipping_address_dropdown"
                @onClick="onTracking($event)"
                @update:inputValue="onFormUpdateValue()"
        ></FormAddressDropdown>
        <Checkbox
                v-model:check="formModel.isDefault"
                :text="lbl.shipping.isDefaultAddress"
                data-cy="checkbox_modal_shipping_address_default"
                @onClick="onTracking('save_address')"
                @update:check="onFormUpdateValue()"
                :isNewDesign="true"
        ></Checkbox>
    </div>
</template>
<script>
import { FormHelper } from "@/helper/FormHelper.js";
// import Util from '@/helper/Utility';
//component
import InputTextBorder from "@/components/Input/label/InputTextBorder.vue";
import InputContactNumberBorder from "@/components/Input/label/InputContactNumberBorder.vue";
import FormAddressDropdown from "@/components/Form/FormAddressDropdown.vue";
import Checkbox from "@/components/Input/simple/Checkbox.vue";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
//service
import { FormAddressModel } from "../model/FormAddressModel.js";

export default {
    name: "FormShippingAddress",
    mixins: [LocaleMixin],
    components: {
        InputTextBorder,
        InputContactNumberBorder,
        FormAddressDropdown,
        Checkbox
    },
    props: {
        isAddress: { type:  Object, default: null },
        address: { type: Object, default: null } ,
        editAddress: { type: Boolean }
    },
    data: function() {
        return {
            isSubmitted: false,
            errorInfo: [],
            refresh: true,

            formModel: null,
            addressModel: null,
            isEditAddress: null,
            isDefaultAddress: false
        };
    },
    created: function() {
        this.initForm(null);
        this.errorInfo = FormHelper.genErrorInfo(5);

        if (this.formModel.hasCache()) {
            this.formModel.loadCache();
            this.addressModel = this.formModel
        } else if (this.isAddress || this.address) {
            this.isEditAddress = this.isAddress.redeemShippingAddressConfigModel;
            this.isSaveDefaultAddress();
        }
    },
    methods: {
        initForm: function() {
            this.isSubmitted = false;

            this.addressModel = new FormAddressModel();
            this.formModel = new FormAddressModel();

            this.refresh = false;
            this.$nextTick(() => {
                this.refresh = true;
            });
        },

        clearForm: function() {
            this.initForm(null);
        },
        submitForm: function() {
            this.isSubmitted = true;
            if (this.validate()) {
                if (this.isEditAddress) {
                    return this.isEditAddress;
                } else {
                    this.formModel.setValueFromAddressModel(this.formModel);
                    return this.formModel;
                }
            }
            return null
        },
        isSaveDefaultAddress: function() {
            if (this.isAddress && this.isAddress.isDefault || this.editAddress || this.isEditAddress) {
                this.addressModel = this.isAddress || this.isEditAddress;
                this.formModel = this.isAddress || this.isEditAddress;
            }
        },

        validate: function() {
            return FormHelper.validate(this.errorInfo);
        },

        onFormUpdateValue: function () {
            this.formModel.saveCache()
        },

        //#region tracking
        onTracking: function(data){
            if(!data) return;

            let track_action = '';

            switch (data){
                case 'firstname':
                    track_action = 'click_name';
                    break;
                case 'lastname':
                    track_action = 'click_last_name';
                    break;
                case 'mobile':
                    track_action = 'click_mobile';
                    break;
                case 'address':
                    track_action = 'click_address';
                    break;
                case 'zipcode':
                    track_action = 'click_post_code';
                    break;
                case 'province':
                    track_action = 'click_province';
                    break;
                case 'district':
                    track_action = 'click_district';
                    break;
                case 'subdistrict':
                    track_action = 'click_sub_district';
                    break;
                case 'save_address':
                    track_action = 'click_save_address';
                    break;
            }

            this.tracking.event('campaign_delivery', track_action, null, null);
        },
        //#endregion tracking
    },
}
</script>
<style lang="scss" scoped>
</style>
